import { entityAPI, logAPI } from "api/GenericAPI";
import { Event, EventLog, EventRegistration } from "api/Interactions/InteractionsInterfaces";


// ================== API Factory ==================
export const eventsAPI = entityAPI<Event>("interactions", "events");
export const eventLogAPI = logAPI<EventLog>("interactions", "events");

